import { useLocation, useNavigate } from "react-router";
import Hdashboard from "../../../components/Hdashboard";
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useRef, useState } from "react";
import { TOAST_ERROR, TOAST_SUCCESS, convertToBase64 } from "../../../utils/common.service";
import { uploadImageOnAWS } from "../../aws/Service";
import { add_category, add_subcategory } from "../../../api/apiHandler";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import Select from "react-select";

export default function AddSubCategory({ isLoader }) {
    const navigate = useNavigate()
    const location = useLocation();
    const categoryId = location.state.categoryId;
    const CategoryName = location.CategoryName;

    const subcategorySchema = Yup.object({
        // category_for: Yup.string().required("Please select category for"),
        category_for: Yup.array()
            .min(1, "Please select at least one category")
            .required("Please select at least one category"),
        subcategory_name: Yup.string()
            .matches(/^[a-zA-Z0-9!@#\$%\^&\*\(\)_\+\-=\[\]{};':"\\|,.<>\/?\s]+$/, 'Please enter proper subcategory name')
            .required('Please enter category name'),
    });

    const categoryForm = useFormik({
        initialValues: {
            subcategory_name: '',
            // category_for: 'class'
            category_for: []
        },
        validationSchema: subcategorySchema,
        validateOnBlur: false,
        onSubmit: async (data) => {
            var obj = {
                subcategory_name: data?.subcategory_name,
                category_id: categoryId,
                category_for: data?.category_for?.join(',')
            }
            isLoader(true)
            add_subcategory(obj).then((resposnse) => {
                if (resposnse.code == 1) {
                    TOAST_SUCCESS(resposnse.message);
                    navigate(-1)
                    isLoader(false)
                } else {
                    TOAST_ERROR(resposnse.message);
                    isLoader(false)
                }
            });
        }
    });

    const { values, setFieldValue } = categoryForm;

    const handleMainCategoryChange = (e) => {
        const selectedMainCategoryId = e.target.value;
        categoryForm.setFieldValue('category_for', selectedMainCategoryId);
    };

    const handleBack = () => {
        navigate(-1);
    };
    const displayError = (fieldName) =>
        categoryForm.touched[fieldName] && categoryForm.errors[fieldName];

    const options = [
        { value: "class", label: "Class" },
        { value: "club", label: "Club" },
        { value: "quiz", label: "Quiz" },
        { value: "competition", label: "Competition" },
    ];

    return <>
        <JqueryLoad />
        <Hdashboard />
        <main>
            <div className="dashboard-app d-lg-flex">
                <header className="dashboard-toolbar d-lg-flex justify-content-between">
                    <div className="align-items-center justify-content-between d-flex">
                        <div className="d-flex align-items-center">
                            <a className="menu-toggle align-items-center d-lg-none d-flex">
                                <i className="fa fa-bars" />
                            </a>
                            <a href="index.php" className="d-lg-none d-block brand-logo">
                                <img src="./assets/images/logo.png" alt="logo" />
                            </a>
                        </div>
                    </div>
                </header>
                <div className="mx-5 mt-4">
                    <span onClick={handleBack}>
                        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313" ></path>
                        </svg>
                        <span className="ms-2">Back</span>
                    </span>
                    <p className="d-flex justify-content-center fs-3 fw-500"> Add SubCategory</p>
                    <div className="row align-items-center justify-content-center mt-5">
                        <div className="col-lg-6">
                            <div className="card border-purple p-4" >
                                <form onSubmit={categoryForm.handleSubmit} className="custom_form mt-4">
                                    <div className="form-group mb-4">
                                        <label className="mb-2">Category:</label>

                                        <Select
                                            isMulti
                                            name="category_for"
                                            options={options}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            value={options.filter((opt) =>
                                                values.category_for.includes(opt.value)
                                            )}
                                            onChange={(selected) => {
                                                setFieldValue(
                                                    "category_for",
                                                    selected ? selected.map((opt) => opt.value) : []
                                                );
                                            }}
                                        />
                                        {displayError("category_for") && (
                                            <div className="text-danger">{categoryForm.errors.category_for}</div>
                                        )}
                                    </div>
                                    {/* <div className="form-group mb-4">
                                        <label className="mb-2">Category:</label>

                                        <select
                                            onChange={(e) => handleMainCategoryChange(e)}
                                            name="category_for"
                                            className="form-select"
                                            multiple
                                        >
                                            <option value="class">Class</option>
                                            <option value="club">Club</option>
                                            <option value="quiz">Quiz</option>
                                            <option value="competition">Competition</option>
                                        </select>
                                        {displayError("category_for") && (
                                            <div className="text-danger">{categoryForm.errors.category_for}</div>
                                        )}
                                    </div> */}
                                    <div className="form-group mb-4">
                                        <label className="mb-2">SubCategory Name:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="subcategory_name"
                                            onChange={categoryForm.handleChange}
                                            value={categoryForm.values.subcategory_name}
                                        />
                                        {displayError("subcategory_name") && (
                                            <div className="text-danger">{categoryForm.errors.subcategory_name}</div>
                                        )}
                                    </div>
                                    <div className="d-flex justify-content-center mt-3">
                                        <button type="submit" className="btn-theme bg-yellow mb-xl-0 mb-3 d-inline-block">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </>
}